"use strict";
import { useAccountDrawer, useShowMoonpayText } from "components/AccountDrawer/MiniPortfolio/hooks";
import ConnectionErrorView from "components/WalletModal/ConnectionErrorView";
import { Option } from "components/WalletModal/Option";
import { useOrderedConnections } from "components/WalletModal/useOrderedConnections";
import { PRIVY_ENABLED } from "components/Web3Provider/privy/PrivyAppProvider";
import { PrivyLoginOptions } from "components/Web3Provider/privy/PrivyLoginOptions";
import { Trans, useTranslation } from "react-i18next";
import { CONNECTION_PROVIDER_IDS } from "constants/web3";
import { Flex, Separator, Text } from "ui/src";
export default function WalletModal() {
  const { t } = useTranslation();
  const showMoonpayText = useShowMoonpayText();
  const connectors = useOrderedConnections();
  const accountDrawer = useAccountDrawer();
  return <Flex
    backgroundColor="$surface1"
    pt="$spacing16"
    px={12}
    pb="$spacing20"
    flex={1}
    gap="$gap16"
    data-testid="wallet-modal"
  >
      <ConnectionErrorView />
      <Flex row justifyContent="space-between" width="100%">
        <Text variant="subheading2">{t("common.connectAWallet.button")}</Text>
      </Flex>

      <Flex gap="$gap12">
        <Flex row alignItems="flex-start">
          <Flex borderRadius="$rounded16" overflow="hidden" width="100%" data-testid="option-grid">
            {PRIVY_ENABLED && <>
                <PrivyLoginOptions onDone={accountDrawer.close} />
                <Separator />
              </>}
            <Option connectorId={CONNECTION_PROVIDER_IDS.BINANCE_W3W_CONNECTOR_ID} />
            <Separator />
            {connectors.map((c, index) => <Flex key={c.uid}>
                <Option connectorId={c.id} detected={c.isInjected} />
                {index < connectors.length - 1 ? <Separator /> : null}
              </Flex>)}
          </Flex>
        </Flex>
        <Flex gap="$gap8">
          {showMoonpayText && <Flex borderTopWidth={1} pt="$spacing8" borderColor="$surface3" px="$spacing4">
              <Text variant="body4" color="$neutral3">
                <Trans i18nKey="moonpay.poweredBy" />
              </Text>
            </Flex>}
        </Flex>
      </Flex>
    </Flex>;
}
